import type { ChatMessage } from '../types'

export type ApprovalPlan = NonNullable<NonNullable<ChatMessage['approval']>['plan']>

export interface GeneratingSpec {
  tags: string[]
  aspectClass: string
}

const ASPECT_OPTION = /aspect.?ratio/i

export function aspectRatioClass(ratio: string | undefined) {
  if (!ratio) {
    return 'aspect-square'
  }
  const match = ratio.trim().match(/^(\d+)\s*[:/]\s*(\d+)$/)
  if (!match) {
    return 'aspect-square'
  }
  const width = Number(match[1])
  const height = Number(match[2])
  if (!width || !height || width === height) {
    return 'aspect-square'
  }
  return `aspect-[${width}/${height}]`
}

export function generatingSpec(
  plan: ApprovalPlan | undefined,
  modelLabel?: string,
): GeneratingSpec {
  const tags = [
    modelLabel || plan?.model,
    ...(plan?.options ?? []).map(option => option.value || option.name),
  ].flatMap(tag => (tag ? [tag] : []))
  const aspect = plan?.options.find(option => ASPECT_OPTION.test(option.name))?.value
  return { tags, aspectClass: aspectRatioClass(aspect) }
}

export function previousApproval(messages: readonly ChatMessage[], messageId: string) {
  const index = messages.findIndex(message => message.id === messageId)
  if (index === -1) {
    return undefined
  }
  const window = messages.slice(0, index + 1)
  for (let cursor = window.length - 1; cursor >= 0; cursor -= 1) {
    const approval = window[cursor]?.approval
    if (approval?.plan || approval?.prompt) {
      return approval
    }
  }
  return undefined
}

export function planForGenerating(messages: readonly ChatMessage[], mediaMessageId: string) {
  const index = messages.findIndex(message => message.id === mediaMessageId)
  const window = index === -1 ? messages : messages.slice(0, index + 1)
  for (let cursor = window.length - 1; cursor >= 0; cursor -= 1) {
    const approval = window[cursor]?.approval
    const plan = approval?.plan
    if (!plan) {
      continue
    }
    const modelLabel =
      approval.modelChoices?.find(choice => choice.model === plan.model)?.label || plan.model
    return { plan, modelLabel }
  }
  return undefined
}
